import {
  fieldServiceType,
  fieldServiceTypeFullName,
} from "../types/index.const";

const fieldServiceTypeOptions = fieldServiceTypeFullName.map((el, index) => ({
  value: fieldServiceType[index],
  label: el,
}));
export default fieldServiceTypeOptions;
